export default "https://cdn-static.gokick.com/assets/adaefb0e3fd6b18bbcda680789a7f58b9251a870/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";